import { useState } from 'react'

const useClose = () => {
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const onClose = () => setIsOpen(false);

    const onOpen = () => setIsOpen(true);

    return {
        isOpen,
        onClose,
        onOpen
    }
}

export default useClose